import { render, staticRenderFns } from "./btn-loading.vue?vue&type=template&id=27b73b6e&"
import script from "./btn-loading.vue?vue&type=script&lang=js&"
export * from "./btn-loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports